export const LOGOS = {
  "google-workspace": "/logos/google.webp",
  slack: "/logos/slack.png",
  teams: "/logos/teams.webp",
  microsoft: "/logos/microsoft365.png",
  quickbooks: "/logos/quickbooks.png",
  netsuite: "/logos/netsuite.webp",
  sap: "/logos/sap.png",
  oracle: "/logos/oracle.png",
  workday: "/logos/workday.png",
  rippling: "/logos/rippling.png",
  gusto: "/logos/gusto.png",
  brex: "/logos/brex.png",
  ramp: "/logos/ramp.png",
  amex: "/logos/amex.png",
  visa: "/logos/visa.png",
  xero: "/logos/xero.png",
  adp: "/logos/adp.webp",
  mastercard: "/logos/mastercard.png",
};
